import { Constants } from "../constants/constants";
import { Injectable } from "@angular/core";
import { HttpClient, HttpParams, HttpHeaders } from "@angular/common/http";

import { Observable, of, throwError } from "rxjs";
import { catchError } from "rxjs/operators";

import Swal from "sweetalert2/dist/sweetalert2.all.js"; //CAMBIA EN PROXIMAS VERSIONES EN ESTA DEBE IMPORTARSE ASI
import { Utils } from "../utils/utils";

@Injectable({
  providedIn: "root"
})
export class ArchivosService {
  constructor(private http: HttpClient, private utils: Utils) {}

  public getInformeCarguesRealizados(agencia, usuarioConsulta, idUsuario, fechaInicial, fechaFinal): Observable<any> {
    const url = Constants.BASE_URL + Constants.URL_ARCHIVO + '/' + idUsuario + '/' + fechaInicial + '/' + fechaFinal + '/' + agencia + '/' + usuarioConsulta;
    return this.http.get<any>(url /*, {headers:httpHeaders}*/).pipe(
      catchError(err => {
        console.log(JSON.stringify(err));
        if (err.status === 401) {
          this.utils.cerrarSesion();
        } else {
          Swal.fire({
            title: 'Error Cargues',
            text: 'Error Mostrando Cargues Realizados.',
            type: 'error'
          });
        }
        
        return throwError(err);
      })
    );
  }

  public postArchivo(
    idProceso,
    idUsuario,
    archivo: File,
    nombre
  ): Observable<any> {
    const url =
      Constants.BASE_URL +
      Constants.URL_ARCHIVO +
      "/" +
      idProceso +
      "/" +
      idUsuario;
    const formData: FormData = new FormData();
    formData.append("file", archivo, nombre);
    return this.http.post<any>(url, formData).pipe(
      catchError(err => {
        if (err.status === 401) {
          this.utils.cerrarSesion();
        } else {
          Swal.fire({
            title: "Error Carga De Archivo",
            text: "Verifique la estructura del archivo.",
            type: "error",
            confirmButtonColor: "#127570"
          });
        }
        return throwError(err);
      })
    );
  }

  public postProcesoCargue(infoCargue): Observable<any> {
    const url = Constants.BASE_URL + Constants.URL_ARCHIVO;

    return this.http.post<any>(url, infoCargue).pipe(
      catchError(err => {
        if (err.status === 401) {
          this.utils.cerrarSesion();
        } else {
          Swal.fire({
            title: "Error Proceso Cargue",
            text: "Verifique El Proceso.",
            type: "error",
            confirmButtonColor: "#127570"
          });
        }
        
        return throwError(err);
      })
    );
  }
}
